import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ReportsService = /** @class */ (function () {
    function ReportsService(http) {
        this.http = http;
    }
    //
    /*
  
    download
    {{BASE_URL_COMMON_API}}/v1/employer/reports/from-user/:id/file
  
    distinzione xlsx da csv e pdf
    */
    ReportsService.prototype.getReports = function (id) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/reports/from-user/" +
            id);
    };
    ReportsService.prototype.downloadFile = function (id) {
        return this.http.get(environment.baseUrlWs +
            environment.wsVerison +
            "employer/reports/from-user/" +
            id +
            "/file", { observe: "response", responseType: "arraybuffer" });
    };
    ReportsService.ngInjectableDef = i0.defineInjectable({ factory: function ReportsService_Factory() { return new ReportsService(i0.inject(i1.HttpClient)); }, token: ReportsService, providedIn: "root" });
    return ReportsService;
}());
export { ReportsService };
